import type { Reply } from 'models';
import { useMemo } from 'react';

type P = {
  commentOrReplyId?: string;
  comments: Reply[];
  commentsPerPage: number;
};

export const useCommentDisplayInitialCount = ({ commentOrReplyId, comments, commentsPerPage }: P) => {
  const commentIndex = useMemo(
    () => (commentOrReplyId ? comments.findIndex((comment) => comment.id === commentOrReplyId) : -1),
    [commentOrReplyId, comments],
  );

  const initialDisplayCount = useMemo(() => {
    if (commentIndex === -1) {
      return commentsPerPage;
    }
    const remainingComments = comments.length - commentIndex;
    return Math.max(remainingComments, commentsPerPage);
  }, [commentIndex, comments.length, commentsPerPage]);

  return useMemo(() => initialDisplayCount, [initialDisplayCount]);
};
